import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ShopTattoo, ShopTattooRemove } from "@/domains/barbershop/constants/tatooParlor.ts";
import { IS_DEV } from "@/domains/main/constants/other.ts";

export interface BarbershopState {
  isOpen: boolean;
  services: ShopTattoo;
  currentService?: ShopTattoo;
  selectedService?: ShopTattoo;
  isLoaded?: boolean;
}

const initialState: BarbershopState = !IS_DEV
  ? {
      isOpen: false,
      services: null,
      currentService: null,
      selectedService: null,
      isLoaded: false,
    }
  : {
      isOpen: true,
      services: null,
      currentService: null,
      selectedService: null,
      isLoaded: false,
    };

const barbershopSlice = createSlice({
  name: "barberhshop",
  initialState,
  reducers: {
    setState(state, action: PayloadAction<Partial<BarbershopState>>) {
      return { ...state, ...action.payload };
    },
    setIsOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    setServices(state, action: PayloadAction<ShopTattoo>) {
      state.services = action.payload;
    },
    setCurrentService(state, action: PayloadAction<ShopTattoo>) {
      state.currentService = action.payload;
    },
    setSelectedService(state, action: PayloadAction<ShopTattoo>) {
      state.selectedService = action.payload;
    },

    setIsLoaded(state, action: PayloadAction<boolean>) {
      state.isLoaded = action.payload;
    },
  },
});

export const barbershopReducer = barbershopSlice.reducer;

export const {
  setState,
  setIsOpen,
  setCurrentService,
  setServices,
  setSelectedService,
  setIsLoaded,
} = barbershopSlice.actions;
